import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="All Extra Stories" mdxType="SEO" />
    <p>{`Start Partitio`}</p>
    <h3 {...{
      "id": "oresrush-partitio-1"
    }}>{`Oresrush (Partitio 1)`}</h3>
    <p>{`Buy 2 Soulstone S.`}<br parentName="p"></br>{`
`}{`Hire closest guy.`}</p>
    <p>{`Kill forced battle with Attack > Arrow of Fortune x2 twice.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Light S`}</strong>{`.`}</p>
    <p>{`Kill 1st battle with Attack > Arrow of Fortune x3`}</p>
    <p>{`Buy from Merchant before Giff.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Short Bow (Equip)`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Lump of Silver`}</li>
      </ul>
    </Menu>
    <p>{`Heal before Giff if needed`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "giff"
      }}>{`Giff`}</h4>
      <ol>
        <li parentName="ol">{`Fire S`}</li>
        <li parentName="ol">{`Light S`}</li>
        <li parentName="ol">{`Spear Giff`}</li>
        <li parentName="ol">{`Thunder S`}</li>
        <li parentName="ol">{`Spear x3`}</li>
        <li parentName="ol">{`Arrow of Fortune x4`}</li>
      </ol>
      <p>{`(Might need to heal, fight isn't safe)`}</p>
    </Battle>
    <p>{`Tag `}<strong parentName="p">{`Cropdale`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1600`}</strong>{`. Tag `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`, warp to `}<strong parentName="p">{`Oresrush`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Ryu`}</strong>{`, warp `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Oswald`}</strong>{`. Go to Cape Cold`}</p>
    <h3 {...{
      "id": "cape-cold"
    }}>{`Cape Cold`}</h3>
    <p>{`Mug Retired Scholar for Gold Items (Defend, Staff, Fireball x4)`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$2000`}</strong>{`. TP `}<strong parentName="p">{`Abandoned Village`}</strong>{` and head to Black Market.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "soulstone-merchant-sell"
      }}>{`Soulstone Merchant (Sell)`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
      </ul>
      <h5 {...{
        "id": "soulstone-merchant-buy"
      }}>{`Soulstone Merchant (Buy)`}</h5>
      <ul>
        <li parentName="ul">{`1 Ice S`}</li>
        <li parentName="ul">{`1 Thunder S`}</li>
        <li parentName="ul">{`1 Shadow M`}</li>
        <li parentName="ul">{`2 Ice M`}</li>
        <li parentName="ul">{`5 Fire M`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Get Throne, Battle Ice S + Attack x2`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Ice S, Wind S, Light S`}</strong>{` from Old Man.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <p>{`2 Unerring Ring, Equip 1 on Partitio `}<strong parentName="p">{`2nd Slot`}</strong>{`. (Press Start to switch Slots)`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`. Take the ship to `}<strong parentName="p">{`Toto'haha`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`DONT ACCIDENTLY TAKE IT TO CRACKRIDGE`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Get Castii.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop, buy `}<strong parentName="p">{`Critical Earring`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Ryu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ryu"
    }}>{`Ryu`}</h3>
    <p>{`Get Hikari, replace Castti. Battle Wind S + Light S.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Beastling Bay Anchorage`}</strong></p>
    <h3 {...{
      "id": "beasting-bay-anchorage-1"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Kill battle with Ice M`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Collect + Hired Help`}</li>
        <li parentName="ul">{`Oswald: Lightning Bolt + Elemental Barrage`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Grow on Trees`}</li>
        <li parentName="ul">{`Oswald: Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Cavern of Waves`}</strong>{`.`}<br parentName="p"></br>{`
`}{`S&Q, pick `}<strong parentName="p">{`JP Augmentor`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <p>{`JP Augmentor: Throne`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Canalbrine`}</strong>{`, head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <p>{`West Canalbrine Cost: Clear with Fire M.`}<br parentName="p"></br>{`
`}{`Canalbrine Bridge: Walk.`}<br parentName="p"></br>{`
`}{`Northern Conning Creek Coast: Kill with Fire M.`}<br parentName="p"></br>{`
`}{`Western Conning Creek Coast: Kill with Fire M.`}</p>
    <h3 {...{
      "id": "conning-creek-oswald-ch3-start"
    }}>{`Conning Creek (Oswald Ch3 Start)`}</h3>
    <p>{`Get `}<strong parentName="p">{`Rainbow Bottle`}</strong>{`. `}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`. Go to Inventor, kill with Shadow M.`}</p>
    <p>{`After getting Inventor, `}<strong parentName="p">{`PICK $700`}</strong>{`!.`}<br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Clockbank`}</strong>{`.`}</p>
    <p>{`Southern Clockbank Highroad pick `}<strong parentName="p">{`$6300`}</strong>{`, reset steps with Thief Shrine, enter `}<strong parentName="p">{`Clockbank`}</strong>{`. `}</p>
    <h3 {...{
      "id": "clockbank-partitio-ch2"
    }}>{`Clockbank (Partitio Ch.2)`}</h3>
    <p>{`Hire guy for 20% more Collect.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Mighty Belt`}</strong>{`.`}</p>
    <p>{`Forced fight Fire M.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$7000`}</strong>{`. Kill battle with Fire M`}<br parentName="p"></br>{`
`}{`Don't need night here. Need Latent on Partitio.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Note: If short for Boost Start, give Hikari Inventor.`}<br parentName="p"></br>{`
`}{`Partitio Latent Collect x4, Defend`}<br parentName="p"></br>{`
`}{`Oswald Lightning Bolt`}<br parentName="p"></br>{`
`}{`Hikari E.Bottle 3`}</p>
      </blockquote>
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Mighty Belt: Partitio`}</li>
      </ul>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Boost Start`}</li>
        <li parentName="ul">{`Oswald: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <p>{`All: A Step Ahead`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "garnet-23000hp-4s-spear-axe-fire-thunder"
      }}>{`Garnet 23000HP 4S (Spear Axe Fire Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Oswald: Defend`}</li>
        <li parentName="ul">{`Throne: Fire S`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Axe x3`}</li>
        <li parentName="ul">{`Hikari: Spear x3`}</li>
        <li parentName="ul">{`Partitio: Collect x4`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Latent Guards x4`}</li>
      </ul>
    </Battle>
    <p>{`Go to `}<strong parentName="p">{`Flamechurch`}</strong>{`. Do this menu asap, it makes failed flees suck less.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: -A Step Ahead`}</li>
        <li parentName="ul">{`Throne: -A Step Ahead`}</li>
        <li parentName="ul"><em parentName="li">{`Leave Hikari's On`}</em></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "flamechurch"
    }}>{`Flamechurch`}</h3>
    <p><strong parentName="p">{`Switch to Night`}</strong>{`. Kill Insurgent with Arrow of Fortune x3`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-oswald-ch3-continued"
    }}>{`Conning Creek (Oswald Ch3 Continued)`}</h3>
    <p><strong parentName="p">{`Switch to night`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to house, pick `}<strong parentName="p">{`Fire M`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "clarissa-8212hp-5s-spear-dagger-thunder"
      }}>{`Clarissa 8212HP 5S (Spear Dagger Thunder)`}</h4>
      <ul>
        <li parentName="ul">{`Partitio: Defend, Guards x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong></p>
    <h3 {...{
      "id": "oresrush-throne-ch2"
    }}>{`Oresrush (Throne Ch.2)`}</h3>
    <p>{`Hire `}<strong parentName="p">{`Peddler (25% Refund on Sales)`}</strong><br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Sturdy Pickaxe`}</strong>{`.`}</p>
    <p>{`Finish Chapter, TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-oswald-ch3-continued-1"
    }}>{`Conning Creek (Oswald Ch3 continued)`}</h3>
    <p>{`Switch to night before battle, Defend, Catapult Spear x4`}<br parentName="p"></br>{`
`}{`If ambushed, you can Fire M. You'll need to get one more elsewhere for Bandelam.`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before Stenvar.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "stenvar-19000hp-5s-sword-spear-bow-thunder-shadow"
      }}>{`Stenvar 19000HP 5S (Sword Spear Bow Thunder Shadow)`}</h4>
      <ul>
        <li parentName="ul">{`Partitio: Defend, HHB x4`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-2"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Axe of Avarice: Partitio`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}</p>
    <p>{`Either run (escape rate should be decent) or clear with Catapult Axe x3`}<br parentName="p"></br>{`
`}{`Southern Crackridge Wilds: switch to night before you get the battle, clear with Catapult x3 Axe`}</p>
    <h3 {...{
      "id": "western-crackridge-wilds"
    }}>{`Western Crackridge Wilds`}</h3>
    <p>{`S&Q. Tag `}<strong parentName="p">{`Crackridge`}</strong>{` and head to Merchant Guild.`}<br parentName="p"></br>{`
`}{`Kill battle again. Get `}<strong parentName="p">{`Merchant Guild`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Flamechurch`}</strong>{`. Head to `}<strong parentName="p">{`Montwise`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Run from small battle, kill Borderfall battle with Catapult x2`}</p>
    <h3 {...{
      "id": "montwise-oswald-ch4"
    }}>{`Montwise (Oswald Ch4)`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Light M & Shadow M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Merchant, Collect + Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Throne: `}<strong parentName="li">{`HP Thief`}</strong>{`, Merchant, Collect + Donate BP + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-3"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: +A Step Ahead`}</li>
        <li parentName="ul">{`Throne: +A Step Ahead +Boost Start +Grow on Trees`}</li>
        <li parentName="ul">{`Oswald: +A Step Ahead +Boost Start +Grow on Trees`}</li>
      </ul>
    </Menu>
    <p>{`Underground Laboratory: Walk to pick `}<strong parentName="p">{`$14000`}</strong>{`. Walk to 2nd door from 4 door section, Travel Banter.`}<br parentName="p"></br>{`
`}{`Run rest, pick `}<strong parentName="p">{`Fire L`}</strong>{`. `}<strong parentName="p">{`SWITCH TO NIGHT`}</strong></p>
    <p>{`Kill forced battle with HHG x3`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grieving-golem-620000hp-7s-spear-staff-wind-light"
      }}>{`Grieving Golem 620000HP 7S (Spear Staff Wind Light)`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Crit Scope`}</li>
        <li parentName="ul">{`Oswald: Attack x3`}</li>
        <li parentName="ul">{`Throne: Spear`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Check Throne's Latent Power here, want it full.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x3`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Oswald: Shadow M`}</li>
        <li parentName="ul">{`Throne: HHG x4`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: 4 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-4"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: -A Step Ahead +Evil Ward`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Cape Cold`}</strong>{` and head to `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <p>{`Check Latent during walk, want full Latent on Throne. If you don't have it stay at an inn before Yurinas.`}</p>
    <p>{`Get `}<strong parentName="p">{`Scholar Guild`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom-throne-ch2-start"
    }}>{`Winterbloom (Throne Ch2 Start)`}</h3>
    <p>{`Go to Tavern`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Oswald > Hikari`}</li>
      </ul>
    </Menu>
    <p>{`If needed, can Steal `}<strong parentName="p">{`Ice M`}</strong>{` from Old Man in Inn or `}<strong parentName="p">{`Wind M`}</strong>{` from Sidequest lady.`}<br parentName="p"></br>{`
`}{`Turn in Sturdy Pickaxe quest to get `}<strong parentName="p">{`Rusty Sword`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-hikari-ch2"
    }}>{`Montwise (Hikari Ch2)`}</h3>
    <p>{`Battle 1: Defend, Spear x3, M Stone`}<br parentName="p"></br>{`
`}{`Battle 2: Ice M`}<br parentName="p"></br>{`
`}{`Zeto: Thunder M, Attack x3, M Stone`}</p>
    <p>{`If no M Stones left, buy/steal `}<strong parentName="p">{`Wind M`}</strong>{` from guy sitting on bench.`}</p>
    <p>{`Bandelam: Fire L, M Stone`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bandelam-20000hp-6s-spear-dagger-axe-fire-light"
      }}>{`Bandelam 20000HP 6S (Spear Dagger Axe Fire Light)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Defend`}</li>
        <li parentName="ul">{`Hikari: Spear x2`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Attack x4`}</li>
        <li parentName="ul">{`Throne: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`Switch to Night, re-enter Arena. Ambush Fainthearted Youth.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "yurinas-30000hp-6s-sword-dagger-axe-ice-wind"
      }}>{`Yurinas 30000HP 6S (Sword Dagger Axe Ice Wind)`}</h4>
      <p>{`T1: Defend / Armor Corrosive if 1st T2`}<br parentName="p"></br>{`
`}{`T2: `}<strong parentName="p">{`Latent`}</strong>{` Armor Corrosive, HHV x4`}</p>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: -Mighty Belt`}</li>
        <li parentName="ul">{`Throne: -JP Augmentor +Mighty Belt +Champion Belt`}</li>
        <li parentName="ul">{`Temenos: +`}{`[S2]`}{`JP Augmentor`}</li>
      </ul>
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Partitio > Throne`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Inventor`}</li>
        <li parentName="ul">{`Hikari: Scholar, 2 Skills, Merchant, Collect + Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Partitio: Scholar, 4 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-5"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: +EM +Grow On Trees +Boost Start`}</li>
        <li parentName="ul">{`Partitio: -Grow on Trees +EM +Extra Experience `}</li>
        <li parentName="ul">{`Temenos: +A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`, head to `}<strong parentName="p">{`Wellgrove`}</strong>{`. Tag `}<strong parentName="p">{`Sai`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Optionally pick `}<strong parentName="p">{`$7200`}</strong>{` before `}<strong parentName="p">{`Wellgrove`}</strong>{`. (Money for Vados is incredibly tight).`}</p>
    <h3 {...{
      "id": "wellgrove-hikari-ch3"
    }}>{`Wellgrove (Hikari Ch3)`}</h3>
    <p>{`Have 2 Travel Banters to skip encounter. Pick `}<strong parentName="p">{`$10000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Battle: HHG x3`}<br parentName="p"></br>{`
`}{`Challenge: Defend, HHB x4`}</p>
    <p>{`TP `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sai"
    }}>{`Sai`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Rotten Meat`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Fort S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Warrior Guild`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine-temenos-ch2"
    }}>{`Canalbrine (Temenos Ch2)`}</h3>
    <p>{`Talk to Tavern Keeper.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <p>{`Castti > Hikari`}</p>
    </Menu>
    <p>{`Coerce top left suspect.`}<br parentName="p"></br>{`
`}{`Mystic Staff, Staff, Staff x4.`}</p>
    <p>{`Switch to day. Switch to night before fight.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vados-the-architecht-14000hp-6s-spear-dagger-ice-light"
      }}>{`Vados the Architecht 14000HP 6S (Spear Dagger Ice Light)`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-temenos-ch3"
    }}>{`Crackridge (Temenos Ch3)`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$9200`}</strong>{`. Finish Chapter`}</p>
    <p>{`Head to `}<strong parentName="p">{`Gravell`}</strong><br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{`. Switch to night.`}</p>
    <p>{`Battle: HHG x4`}</p>
    <p>{`Enter `}<strong parentName="p">{`Gravell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gravell"
    }}>{`Gravell`}</h3>
    <p>{`Soothe guy guarding Armsmaster house. Get `}<strong parentName="p">{`Armsmaster`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Exit Gravell, pick `}<strong parentName="p">{`$23000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage-2"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Will get Shadow Battle here, Break and flee.`}<br parentName="p"></br>{`
`}{`Run to `}<strong parentName="p">{`Tropu'hopu`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Hunter Guild`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tropuhopu"
    }}>{`Tropu'hopu`}</h3>
    <blockquote>
      <p parentName="blockquote">{`There's a lot to do here, don't forget anything!`}</p>
    </blockquote>
    <p>{`Go to Item Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "item-sell"
      }}>{`Item Sell`}</h5>
      <ul>
        <li parentName="ul">{`Conqueror's Blade`}</li>
        <li parentName="ul">{`Axe of Avarice`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`STEAL Fort M FFS DONT FORGET FOR ONCE`}</strong></p>
    <p>{`Go to Inn. Hire NPC for 20% off purchases. `}<em parentName="p">{`If Partitio isn't full Latent, stay at inn.`}</em></p>
    <p>{`Go to Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-2"
      }}>{`Party`}</h5>
      <p>{`Oswald > Castti`}</p>
    </Menu>
    <p>{`Go buy Boat!`}</p>
    <h3 {...{
      "id": "sea"
    }}>{`Sea`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Reinforcing Jam`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`New Delsta Harbor`}</strong>{`, get back on boat. Pick `}<strong parentName="p">{`EXP Augmentor`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`. Get on Boat.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Sunken Golden Statue`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`, head to `}<strong parentName="p">{`Merry Hills`}</strong>{`. Run from both battles on the way.`}</p>
    <h3 {...{
      "id": "merry-hills"
    }}>{`Merry Hills`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Diamond Dagger`}</strong>{`.`}</p>
    <p>{`Talk to Weapon Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-sell"
      }}>{`Weapon Sell`}</h5>
      <ul>
        <li parentName="ul">{`Sunken Golden Statue`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-3"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Diamond Dagger: Throne`}</li>
        <li parentName="ul">{`EXP Augmentor: Temenos`}</li>
        <li parentName="ul">{`Nuts: Throne`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Merchant`}</li>
        <li parentName="ul">{`Temenos: Hunter, `}<strong parentName="li">{`Abating Orb`}</strong></li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong></p>
    <h3 {...{
      "id": "new-delsta-oswald-partitio-ch1"
    }}>{`New Delsta (Oswald Partitio Ch1)`}</h3>
    <p>{`Finish Chapter.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Gravell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gravell-oswald-ch4"
    }}>{`Gravell (Oswald Ch4)`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Light M & Shadow M`}</strong>{`.`}</p>
    <p>{`Mug 1: Attack/Defend, HHG x4, M Stone`}<br parentName="p"></br>{`
`}{`Mug 2: HHB x3`}<br parentName="p"></br>{`
`}{`Mug 3: Defend, HHB x4`}<br parentName="p"></br>{`
`}{`Mug 4: Thunder L + M Stone`}<br parentName="p"></br>{`
`}{`Mug 5: Defend, HHB x4`}</p>
    <p>{`Run from battles in Duskruin. If Bats, can Shadow L.`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before trigger.`}</p>
    <p>{`Remnants: HHG x4, P.Dagger C.Axe x4`}</p>
    <blockquote>
      <p parentName="blockquote">{`Requires full Partitio Latent.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "harvey-80000hp-10s-spear-axe-fire-ice-thunder"
      }}>{`Harvey 80000HP 10S (Spear Axe Fire Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Oswald: Defend`}</li>
        <li parentName="ul">{`Partitio: Elemental Barrage x3`}</li>
        <li parentName="ul">{`Temenos: Axe x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Elemental Barrage`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Partitio: Latent HHB x4`}</li>
        <li parentName="ul">{`Temenos: Abating Orb`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`M1: Collect x3`}</li>
        <li parentName="ul">{`M2: HHB x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Cropdale`}</strong></p>
    <h3 {...{
      "id": "cropdale"
    }}>{`Cropdale`}</h3>
    <p>{`Get Agnea, replace Oswald. `}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-5"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Merchant, 2 Skills + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: All Thief Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-6"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Life in the Shadows`}</li>
        <li parentName="ul">{`Temenos: +Boost Start`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Merry Hills`}</strong>{`. Go fight Assassins.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "assassins"
      }}>{`Assassins`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Defend`}</li>
        <li parentName="ul">{`Temenos: HHM`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Temenos: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-agnea-ch2"
    }}>{`New Delsta (Agnea Ch2)`}</h3>
    <p>{`Entreat `}<strong parentName="p">{`Fort M & Nourish M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After doing 1st Allure:`}</p>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`, head to `}<strong parentName="p">{`Stormhail`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Ambush Guard. Switch back to Day. Run from everything on this trip.`}</p>
    <h3 {...{
      "id": "stormhail-temenos-ch3"
    }}>{`Stormhail (Temenos Ch3)`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Maybe reset night/day here, so dungeon is day.`}</p>
    </blockquote>
    <p>{`After Crick Guides `}<strong parentName="p">{`switch to day`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before end of last stairs.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "deputy-cubaryi-54000hp-5s-spear-axe-staff-19200-collect"
      }}>{`Deputy Cubaryi 54000HP 5S (Spear Axe Staff) $19200 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Axe`}</li>
        <li parentName="ul">{`Partitio: Latent Attack x3`}</li>
        <li parentName="ul">{`Temenos: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul"><em parentName="li">{`If order is M1 M2 Throne do HHB x4 Collect x4 HP Thief x4`}</em></li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`M1: Collect x4`}</li>
        <li parentName="ul">{`M2: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Winterbloom`}</strong></p>
    <h3 {...{
      "id": "winterbloom-throne-ch2-continued"
    }}>{`Winterbloom (Throne Ch2 Continued)`}</h3>
    <p><strong parentName="p">{`ENTREAT FORT L`}</strong></p>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "bergomi-15000hp-4s-sword-bow-fire"
      }}>{`Bergomi 15000HP 4S (Sword Bow Fire)`}</h5>
      <p>{`HHG x3 + HP Thief x3`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-agnea-ch2-continued"
    }}>{`New Delsta (Agnea Ch2 Continued)`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-4"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Fort Nuts: Throne`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-6"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: 2 Merchant Skills, Scholar, +Elemental Barrage`}</li>
        <li parentName="ul">{`Partitio: 2 Skills, Hunter, `}<strong parentName="li">{`Abating Orb`}</strong></li>
        <li parentName="ul">{`Agnea: Merchant, +Collect +Ember +Donate BP +Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-7"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: -Heightened Senses +Full Power`}</li>
        <li parentName="ul">{`Partitio: -Boost Start +Full Power`}</li>
        <li parentName="ul">{`Agnea: All Skills`}</li>
      </ul>
    </Menu>
    <p>{`Take bottom path and Allure Lady on the way.`}<br parentName="p"></br>{`
`}{`Switch to night before boss`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lamani"
      }}>{`La'mani`}</h4>
      <p>{`If Throne first, HP Thief x3 + Shadow L`}<br parentName="p"></br>{`
`}{`Else, knock off 3 Shield and HP Thief x3`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Tropu'hopu`}</strong></p>
    <h4 {...{
      "id": "tropuhopu-agnea-ch3"
    }}>{`Tropu'hopu (Agnea Ch3)`}</h4>
    <p>{`Entreat `}<strong parentName="p">{`Marksman Bow & Light Nut L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After finishing Chapter run to `}<strong parentName="p">{`Nameless Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "nameless-village-temenos-ch4"
    }}>{`Nameless Village (Temenos Ch4)`}</h3>
    <p>{`Guide Story Guy.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` Before Fight`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "kaldena-100000hp-8s-spear-staff-ice-wind-collect-1200"
      }}>{`Kaldena 100000HP 8S (Spear Staff Ice Wind) Collect $1200`}</h4>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Agnea: Donate BP Throne`}</li>
        <li parentName="ul">{`Partitio: Latent Attack x4`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x3`}</li>
        <li parentName="ul">{`Agnea: HHB x4`}</li>
        <li parentName="ul">{`Partitio: Abating Orb`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-partitio-ch3-continued"
    }}>{`Wellgrove (Partitio Ch3 Continued)`}</h3>
    <p>{`After Tavern cutscene, `}<strong parentName="p">{`Swap Hikari > Agnea`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-7"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Warrior, All Skills, Inventor`}</li>
        <li parentName="ul">{`Hikari: Merchant`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-8"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -Grow on Trees +Surpassing Power`}</li>
      </ul>
    </Menu>
    <p>{`Get `}<strong parentName="p">{`Dancer Guild`}</strong>{`.`}</p>
    <p>{`After buying stuff, `}<strong parentName="p">{`Switch to Night`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "thurston-35000hp-4s-sword-axe-bow-ice-wind-collect-17000"
      }}>{`Thurston 35000HP 4S (Sword Axe Bow Ice Wind) Collect $17000`}</h4>
      <h4 {...{
        "id": "steam-engine-7500hp-spear-dagger-fire-thunder"
      }}>{`Steam Engine 7500HP (Spear Dagger Fire Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3 Steam Engine`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Donate BP x2 Throne`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: LATENT Attack x4`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Merchant 1: HHG x4`}</li>
        <li parentName="ul">{`Merchant 2: Collect x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail-hikari-ch4"
    }}>{`Stormhail (Hikari Ch4)`}</h3>
    <p>{`Switch to Night.`}</p>
    <h5 {...{
      "id": "kunzo"
    }}>{`Kunzo`}</h5>
    <p>{`HHG x3, HP Thief x3. Can Attack x3 if HHG x4`}</p>
    <h5 {...{
      "id": "jin-mei"
    }}>{`Jin Mei`}</h5>
    <p>{`Attack, Attack, Defend, Wild Cut x2, Wild Cut x4`}</p>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`, `}<strong parentName="p">{`$15000`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "rai-mei-55000hp-7s-sword-staff-ice-light-36000-collect"
      }}>{`Rai Mei 55000HP 7S (Sword Staff Ice Light) $36000 Collect`}</h4>
      <blockquote>
        <p parentName="blockquote">{`If you want to 2T for JP bonus, have Temenos Latent x3 Attack T1 and L Stone T2. No need though.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Latent HHB x4`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Hikari: Collect x4`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`Enter `}<strong parentName="p">{`Mei Castle`}</strong>{`, Steal `}<strong parentName="p">{`Fort M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-5"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Fort M: Throne`}</li>
        <li parentName="ul">{`Nourish L: Hikari`}</li>
        <li parentName="ul">{`Nourish M: Temenos`}</li>
        <li parentName="ul"><em parentName="li">{`Need to test Vide damage, I think with Nourish M on Temenos both are safe without Temenos Warrior`}</em></li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Sai`}</strong>{`, head to `}<strong parentName="p">{`Ku`}</strong>{`. Pick `}<strong parentName="p">{`Firestarter`}</strong>{` for selling if something went wrong with money.`}</p>
    <h3 {...{
      "id": "ku-hikari-ch5"
    }}>{`Ku (Hikari Ch5)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ritsu-75000hp-7s-spear-bow-fire-shadow-10000-collect"
      }}>{`Ritsu 75000HP 7S (Spear Bow Fire Shadow) $10000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Spear`}</li>
        <li parentName="ul">{`Partitio: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent E.Barrage x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Hikari: HHG x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "king-mugen-80000hp-6s-spear-axe-thunder-light-18000-collect"
      }}>{`King Mugen 80000HP 6S (Spear Axe Thunder Light) $18000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Attack x2`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Spear`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Partitio: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Pom L / Reinforcing Jam Throne`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`M1: Collect`}</li>
        <li parentName="ul">{`M2: HHB x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "hikari-25000hp-7s-sword-axe-light"
      }}>{`"Hikari" 25000HP 7S (Sword Axe Light)`}</h4>
      <ul>
        <li parentName="ul">{`Defend, HHV x4, HHG x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "enshrouded-king-10s-sword-spear-bow-staff-thunder-wind-collect-26000"
      }}>{`Enshrouded King 10S (Sword Spear Bow Staff Thunder Wind) Collect $26000`}</h4>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Pom M/L Self`}</li>
        <li parentName="ul">{`Partitio: Latent Attack x4`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent Elemental Barrage x4`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
        <li parentName="ul">{`Hikari: Hienka if before Throne, HHB x3 (If no Latent & before, Collect x4)`}</li>
        <li parentName="ul">{`Partitio: Rotten Meat Throne`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: `}<strong parentName="li">{`LATENT`}</strong>{` HP Thief x3, HP Thief x3`}</li>
        <li parentName="ul">{`Merchant 1: Collect x4`}</li>
        <li parentName="ul">{`Merchant 2: HHB x4`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-sell-1"
      }}>{`Weapon Sell`}</h5>
      <ul>
        <li parentName="ul">{`Eclipse Edge`}</li>
        <li parentName="ul">{`Marksman Bow`}</li>
        <li parentName="ul">{`Carnage Bow`}</li>
      </ul>
    </Menu>
    <p>{`Steal `}<strong parentName="p">{`Fort S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Tavern, `}<strong parentName="p">{`Swap Agnea > Hikari`}</strong><br parentName="p"></br>{`
`}{`Switch to night, Entreat `}<strong parentName="p">{`Light Nut L`}</strong>{` from Zeto.`}</p>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-harbor"
    }}>{`Crackridge Harbor`}</h3>
    <p>{`Go buy `}<strong parentName="p">{`Battle-Tested Blade`}</strong>{` from Bandelam`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <h4 {...{
      "id": "sai-agnea-ch4"
    }}>{`Sai (Agnea Ch4)`}</h4>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-6"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Nuts: Throne`}</li>
        <li parentName="ul">{`BT Blade: Throne`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-8"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Armsmaster`}</li>
        <li parentName="ul">{`Agnea: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Temenos: Aelfrics`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle"> 
      <h4 {...{
        "id": "veronica-60000hp-6s-dagger-axe-fire-ice-shadow-12000-collect"
      }}>{`Veronica 60000HP 6S (Dagger Axe Fire Ice Shadow) $12000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Agnea: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: Axe x3`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-throne-ch3"
    }}>{`Wellgrove (Throne Ch3)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mother-42000hp-6s-dagger-bow-ice-light-collect-6000"
      }}>{`Mother 42000HP 6S (Dagger Bow Ice Light) Collect $6000`}</h4>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Agnea: Attack x3 Mother`}</li>
        <li parentName="ul">{`Partitio: Abating Orb Mother`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3 Mother`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-14"
      }}>{`Turn 2`}</h5>
      <p>{`Aebers`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Merry Hills`}</strong>{`.`}</p>
    <h3 {...{
      "id": "merry-hills-agnea-ch5"
    }}>{`Merry Hills (Agnea Ch5)`}</h3>
    <p>{`Kill fight w/ HHB x3 (Aebers if money REALLY bad) `}</p>
    <p>{`Buy/Steal (55%) `}<strong parentName="p">{`Quick Cloak & Ice M`}</strong>{`. (Money is tight, almost certainly steal)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-shop-buy"
      }}>{`Weapon Shop Buy`}</h5>
      <ul>
        <li parentName="ul">{`Swift Shield`}</li>
        <li parentName="ul">{`Dazzling Tiara`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Optimize`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolciana-p1-58000hp-6s-spear-dagger-bow-ice-shadow"
      }}>{`Dolciana P1 58000HP 6S (Spear Dagger Bow Ice Shadow)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Can Abating Orb for +1800EXP (and some JP / Money)`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Agnea: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-15"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolciana-p2-90000hp-8s-sword-dagger-axe-fire-wind"
      }}>{`Dolciana P2 90000HP 8S (Sword Dagger Axe Fire Wind)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`If no Crit Scope before HP Thief this is a range, can just chuck a Stone if you don't kill.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3`}</li>
        <li parentName="ul">{`Agnea: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: Donate BP x3 Throne`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-16"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent E.Barrage x4`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong></p>
    <h3 {...{
      "id": "montwise-throne-ch3-continued"
    }}>{`Montwise (Throne Ch3 continued)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "father-58000hp-7s-spear-dagger-axe-wind-light-collect-9600"
      }}>{`Father 58000HP 7S (Spear Dagger Axe Wind Light) Collect $9600`}</h4>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Agnea: Attack x3`}</li>
        <li parentName="ul">{`Partitio: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Latent E.Barrage x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-17"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong></p>
    <h3 {...{
      "id": "new-delsta-throne-ch4"
    }}>{`New Delsta (Throne Ch4)`}</h3>
    <p>{`After Ambush switch back to day`}</p>
    <p>{`Heal before Claude, `}<strong parentName="p">{`Switch to Night`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "claude-68000hp-9s-dagger-axe-staff-thunder-light-30000-collect"
      }}>{`Claude 68000HP 9S (Dagger Axe Staff Thunder Light) $30000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Sixfold Strike`}</li>
        <li parentName="ul">{`Agnea: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-18"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent E.Barrage x4`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beastling Bay Anchorage`}</strong>{`, Take boat to `}<strong parentName="p">{`Roque Island`}</strong></p>
    <h3 {...{
      "id": "roque-island-partitio-ch4"
    }}>{`Roque Island (Partitio Ch4)`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-9"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Inventor`}</li>
        <li parentName="ul">{`Agnea: Hunter, `}<strong parentName="li">{`Abating Orb`}</strong></li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` after Purchasting Rights.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "steam-tank-obsidian-70000hp-8s-spear-bow-shadow-collect-52000"
      }}>{`Steam Tank Obsidian 70000HP 8S (Spear Bow Shadow) Collect $52000`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Need to Guards x4 ONLY if part of Steam Tank is before whole party.`}<br parentName="p"></br>{`
`}{`A Defend automatically let's you Guard x3 as long as it's before the Guards.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Agnea: Defend`}</li>
        <li parentName="ul">{`Partitio: Latent HHG x3/4`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-19"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Pom S Partitio if HHG x4 T1`}</li>
        <li parentName="ul">{`Throne: Aebers `}</li>
        <li parentName="ul">{`Partitio: HHV x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Flamechurch`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flamechurch-temenos--throne-ch1"
    }}>{`Flamechurch (Temenos & Throne Ch1)`}</h3>
    <p>{`Go to Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-3"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Hikari > Partitio`}</li>
      </ul>
    </Menu>
    <p>{`Coerce Old Man: LATENT E.Barrage x3, Attack`}<br parentName="p"></br>{`
`}{`Guide Old Man`}</p>
    <p>{`Steal `}<strong parentName="p">{`Reinforcing Jam`}</strong>{` (Woman left of the Sacred Flame)`}<br parentName="p"></br>{`
`}{`Finish Chapter. TP `}<strong parentName="p">{`Ryu`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Ryu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ryu-1"
    }}>{`Ryu`}</h3>
    <p>{`Do Quest. TP `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ku-hikari--agnea-ch2-start"
    }}>{`Ku (Hikari & Agnea Ch2 Start)`}</h3>
    <p>{`After Entreating on 2nd screen, TP `}<strong parentName="p">{`Conning Creek`}</strong></p>
    <h3 {...{
      "id": "conning-creek-temenos--throne-ch2-start"
    }}>{`Conning Creek (Temenos & Throne Ch2 Start)`}</h3>
    <p>{`After Stealing map, TP `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ku-hikari--agnea-ch2-continued"
    }}>{`Ku (Hikari & Agnea Ch2 Continued)`}</h3>
    <p>{`Talk to Benkai.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Yomi`}</strong>{`: Defend, HHV x4 (range), (Light) L Stone if alive`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-temenos--throne-ch2-start-1"
    }}>{`Conning Creek (Temenos & Throne Ch2 Start)`}</h3>
    <p>{`Finish Temenos & Throne chapter.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Beastling Bay: Anchorage`}</strong>{`, run to Beastling Village.`}</p>
    <h3 {...{
      "id": "beasting-village"
    }}>{`Beasting Village`}</h3>
    <p>{`Talk to Ochette, `}<strong parentName="p">{`CHOOSE AKALA`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-4"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Castti > Agnea`}</li>
        <li parentName="ul">{`Hikari > Ochette`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong></p>
    <h3 {...{
      "id": "crackridge-ochette-ch2-tera"
    }}>{`Crackridge (Ochette Ch2 Tera)`}</h3>
    <p>{`Switch to night, run out and look for Meep battle.`}<br parentName="p"></br>{`
`}{`I like to kill 1st 2 that aren't meep, just to get levels up for escape rate.`}</p>
    <p>{`Battle: Throne Spring Boots Ochette, Temenos Thunder M`}<br parentName="p"></br>{`
`}{`Ochette Capture, clear battle trying to keep Ochette alive.`}<br parentName="p"></br>{`
`}{`Cook Meep into `}<strong parentName="p">{`Aromatic Jerky`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-10"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Armsmaster`}</li>
        <li parentName="ul">{`Castti: Scholar, 2 Skills, Dancer`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-9"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -Life in the Shadow +Summon Strength`}</li>
        <li parentName="ul">{`Castti: Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`After befriending Pom switch back to day, then `}<strong parentName="p">{`switch to night`}</strong>{` before Tera.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "terakun-43500hp-6s-dagger-axe-staff-ice-light"
      }}>{`Terakun 43500HP 6S (Dagger Axe Staff Ice Light)`}</h4>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-20"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Ochette: Capture`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sai-castti-ch2-sai"
    }}>{`Sai (Castti Ch2 Sai)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "sand-lion-22500hp-5s-spear-axe-ice-light-shadow"
      }}>{`Sand Lion 22500HP 5S (Spear Axe Ice Light Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-21"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Surprise Attack x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-ochette-ch2-acta"
    }}>{`Conning Creek (Ochette Ch2 Acta)`}</h3>
    <p>{`Provoke M Stone. Finish Chapter.`}</p>
    <p>{`TP `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom-castti-ch2"
    }}>{`Winterbloom (Castti Ch2)`}</h3>
    <p>{`Go to Tavern`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Partitio > Throne`}</li>
        <li parentName="ul">{`Temenos > Oswald`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-11"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: Merchant`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "plukk-16000hp-mikk-12000hp-makk-13000hp"
      }}>{`Plukk 16000HP, Mikk 12000HP, Makk 13000HP`}</h5>
      <p>{`Ruffians x2, HHB x4, or HHV x3. Unless you got extra money shouldn't have enough for HHV x3`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong></p>
    <h3 {...{
      "id": "montwise-oswald--partitio-ch2"
    }}>{`Montwise (Oswald & Partitio Ch2)`}</h3>
    <p>{`1st 2 Battle HHB x3, last one HHG x4`}</p>
    <p>{`TP `}<strong parentName="p">{`Abandoned Village`}</strong></p>
    <h3 {...{
      "id": "abandoned-village-castti-ch3"
    }}>{`Abandoned Village (Castti Ch3)`}</h3>
    <p>{`After 4 Inquires talk to Tavern Keeper`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-6"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Throne > Partitio`}</li>
        <li parentName="ul">{`Oswald > Temenos`}</li>
      </ul>
    </Menu>
    <p>{`Finish Chapter, TP `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail-ochette-ch2-glacis"
    }}>{`Stormhail (Ochette Ch2 Glacis)`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-12"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Inventor`}</li>
        <li parentName="ul">{`Temenos: Aelfrics if not learned yet, Scholar`}</li>
        <li parentName="ul">{`Ochette: +Abating Orb, Merchant, +3 Skills +Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-10"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: All Skills`}</li>
      </ul>
    </Menu>
    <p>{`Provoke: Any Stone (Ice S should be good enough, Ice/Shadow L saves maximum animation time), Tera`}<br parentName="p"></br>{`
`}{`Pick Reinforcing Jam if you've used any unrouted ones.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "glacis-54000hp-8s-spear-dagger-bow-fire"
      }}>{`Glacis 54000HP 8S (Spear Dagger Bow Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Ochette: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent E.Barrage x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-22"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Ochette: Capture`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beastling Village`}</strong></p>
    <h3 {...{
      "id": "beastling-village-ochette-ch3"
    }}>{`Beastling Village (Ochette Ch3)`}</h3>
    <p>{`Go to Summit. `}<strong parentName="p">{`Switch to Night`}</strong>{`.`}</p>
    <p>{`3 Battles: Catapult x3`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` for Malamaowl`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "malamaowl-96000hp-7s-dagger-axe-fire"
      }}>{`Malamaowl 96000HP 7S (Dagger Axe Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-23"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent E.Barrage x4`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Castti: Pom L Throne`}</li>
        <li parentName="ul">{`Ochette: `}<strong parentName="li">{`Abating Orb`}</strong></li>
      </ul>
      <h5 {...{
        "id": "turn-3-7"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`, run to `}<strong parentName="p">{`Timberain`}</strong>{`.`}</p>
    <h3 {...{
      "id": "timberain-castti-ch4"
    }}>{`Timberain (Castti Ch4)`}</h3>
    <p>{`Switch to Night before boss.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "trosseau-95000hp-8s-spear-axe-ice-dark"
      }}>{`Trosseau 95000HP 8S (Spear Axe Ice Dark)`}</h4>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Ochette: Axe/Spear x2`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-24"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers `}<em parentName="li">{`Can hit without break, doesn't matter)`}</em></li>
        <li parentName="ul">{`Temenos: Latent + Elemental Barrage x4`}</li>
        <li parentName="ul">{`Ochette: Abating Orb`}</li>
        <li parentName="ul">{`Castti: Pom L Throne`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-8"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Cropdale`}</strong></p>
    <h3 {...{
      "id": "cropdale-castti--ochette-1"
    }}>{`Cropdale (Castti & Ochette 1)`}</h3>
    <p>{`Switch to Night before fight.`}<br parentName="p"></br>{`
`}{`Duorduor: Sword x3 (Surprise Attack x3 if Daytime)`}<br parentName="p"></br>{`
`}{`After finishing TP `}<strong parentName="p">{`Cropdale`}</strong>{` to start part 2`}</p>
    <p>{`Wriggling Shadow: Akala, Akala, Glacis, L Stone`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "creeping-shadow-50000hp-6s-spear-axe-bow-ice-light"
      }}>{`Creeping Shadow 50000HP 6S (Spear Axe Bow Ice Light)`}</h4>
      <h5 {...{
        "id": "turn-1-24"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Ochette: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Latent Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-25"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`, run to Campfire to start `}<strong parentName="p">{`Journey of the Dusk`}</strong>{`.`}</p>
    <h3 {...{
      "id": "journey-of-the-dusk"
    }}>{`Journey of the Dusk`}</h3>
    <p>{`Forced Battle: P.Sword C.Staff x3`}</p>
    <p>{`TP `}<strong parentName="p">{`Beastling Village`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grotesque-monster-120000hp-7s-axe-bow-ice-thunder"
      }}>{`Grotesque Monster 120000HP 7S (Axe Bow Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Nothing`}</li>
        <li parentName="ul">{`Ochette: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-26"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent Attack x4`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
        <li parentName="ul">{`Castti or Ochette: Pom L / Defend and Pom L next turn`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-9"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`After lighting Flame TP `}<strong parentName="p">{`Flamechurch`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flamechurch-1"
    }}>{`Flamechurch`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "arcanette-150000hp-8s-spear-axe-ice-thunder"
      }}>{`Arcanette 150000HP 8S (Spear Axe Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-26"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Ochette: Spear/Axe x3`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-27"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Latent E.Barrage x4`}</li>
        <li parentName="ul">{`Castti or Ochette: Rev Jam / Defend and Rev Jam next turn`}</li>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-10"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Aebers`}</li>
      </ul>
    </Battle>
    <p>{`Go to Church, Light Flame. `}</p>
    <p>{`TP `}<strong parentName="p">{`Ku`}</strong>{`, Head to `}<strong parentName="p">{`Tranquil Grotto`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Agnea > Ochette`}</li>
        <li parentName="ul">{`Castti > Hikari`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong>{` next. `}</p>
    <h3 {...{
      "id": "crackridge"
    }}>{`Crackridge`}</h3>
    <p>{`If Throne Latent not full, rest at inn.`}<br parentName="p"></br>{`
`}{`Before lighting flame menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Partitio > Agnea`}</li>
        <li parentName="ul">{`Hikari > Oswald`}</li>
      </ul>
      <h5 {...{
        "id": "items-7"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Shiny Mirror`}</li>
      </ul>
    </Menu>
    <p>{`After Lighting Flame, do this menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-13"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Armsmaster`}</li>
        <li parentName="ul">{`Oswald: Hunter, `}<strong parentName="li">{`ABATING ORB`}</strong></li>
        <li parentName="ul">{`Temenos: Warrior`}</li>
        <li parentName="ul">{`Agnea: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-11"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -Boost Start +Fleetfoot`}</li>
        <li parentName="ul">{`Partitio: -EM +Hang Tough`}</li>
      </ul>
      <p>{`Close and open menu.`}</p>
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Hikari > Partitio`}</li>
      </ul>
      <h5 {...{
        "id": "world-map"
      }}>{`World Map`}</h5>
      <ul>
        <li parentName="ul">{`TP `}<strong parentName="li">{`New Delsta Anchorage`}</strong></li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`, go to `}<strong parentName="p">{`Vidania`}</strong>{`.`}</p>
    <h3 {...{
      "id": "vidania"
    }}>{`Vidania`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vide-200000hp"
      }}>{`Vide 200000HP`}</h4>
      <h5 {...{
        "id": "turn-1-27"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Sword/Axe x2 Vide`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Oswald: Attack x3 Vide`}</li>
        <li parentName="ul">{`Temenos: Attack Vide`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-28"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Hikari: Attack x4 Vide`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Throne: LATENT Reinforcing, Aebers`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Temenos: Aelfrics Throne`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Oswald: Abating Orb`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Throne: LATENT Reinforcing, Aebers`}</p>
        </li>
      </ul>
      <h5 {...{
        "id": "turn-3-11"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Throne: LATENT Pom S/M/L, Aebers`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vide-phase-2-250000hp"
      }}>{`Vide Phase 2 250000HP`}</h4>
      <h5 {...{
        "id": "turn-1-28"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Latent Springy Boots`}</li>
        <li parentName="ul">{`Ochette: Beastly Howl`}</li>
        <li parentName="ul">{`Partitio: Latent HHB x4`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-29"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Lion Dance x2 Throne (1D)`}</li>
        <li parentName="ul">{`Agnea: Crit Scope Vide (1U)`}</li>
        <li parentName="ul">{`Ochette: HHV x4`}</li>
        <li parentName="ul">{`Partitio: HHV x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-12"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack x3`}</li>
        <li parentName="ul">{`Ochette: Beastly Howl`}</li>
        <li parentName="ul">{`Partitio: `}<strong parentName="li">{`Bow`}</strong>{` x4`}</li>
      </ul>
      <p>{`Party dies now.`}</p>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Throne: Swift Step`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Temenos: Aelfrics Throne`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Oswald: Bow x4`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Throne: LATENT Aebers, Rev Jam self`}</p>
        </li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Throne: Aebers`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Someone after her: Pom L Throne`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Someone else: Plum if needed / nothing`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Throne: Aebers`}</p>
        </li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{` Go to campsite, start Epilogue. Timing ends after 2nd cutscene black screen. GG!`}</p>
    <hr></hr>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h6 {...{
      "id": "211-32723"
    }}>{`2.1.1 3/27/23`}</h6>
    <ul>
      <li parentName="ul">{`Mei Castle Fort M instead of Ku Fort M and Clockbank Light M`}</li>
      <li parentName="ul">{`Hikari as survivor for Vide instead of Oswald`}</li>
    </ul>
    <h6 {...{
      "id": "210-32523"
    }}>{`2.1.0 3/25/23`}</h6>
    <ul>
      <li parentName="ul">{`Armsmaster back in.`}</li>
      <li parentName="ul">{`Early game pathing changes, doing Clarissa after Partitio 2 makes the money route early game really free.`}</li>
    </ul>
    <h6 {...{
      "id": "201-32423"
    }}>{`2.0.1 3/24/23`}</h6>
    <p>{`Fix some bad notes for fights & mistakes from restructure.`}</p>
    <h6 {...{
      "id": "200-32423"
    }}>{`2.0.0 3/24/23`}</h6>
    <p>{`Big Reroute, playing around 2 new discoveries and 1 change`}<br parentName="p"></br>{`
`}{`1. Abating Orb nullifying enemy Invincibility before dialogue`}<br parentName="p"></br>{`
`}{`2. Catapult bug/mechanic that let's us throw any weapon type with any equipped weapon's stats.`}<br parentName="p"></br>{`
`}{`3. JP Augmentor is back in`}</p>
    <h6 {...{
      "id": "122-31820222"
    }}>{`1.2.2 3/18/20222`}</h6>
    <ul>
      <li parentName="ul">{`Keep Temenos Scholar for Trosseau, no need for early Sharp L`}</li>
      <li parentName="ul">{`Crit Scope for Tera-kun`}</li>
      <li parentName="ul">{`More precise Inn stays`}</li>
    </ul>
    <h6 {...{
      "id": "121"
    }}>{`1.2.1:`}</h6>
    <ul>
      <li parentName="ul">{`Temenos Inventor until Champ Belt`}</li>
      <li parentName="ul">{`Summon Str Ochette Chapters`}</li>
      <li parentName="ul">{`Fix errors / cleanup`}</li>
    </ul>
    <h6 {...{
      "id": "120-giants-club-cut--reroute"
    }}>{`1.2.0: Giant's Club Cut / Reroute`}</h6>
    <ul>
      <li parentName="ul">{`Cut Giant's Club`}</li>
      <li parentName="ul">{`Diamond Dagger instead of Lockpick`}</li>
      <li parentName="ul">{`Delay Temenos chapters until after Champ Belt`}</li>
      <li parentName="ul">{`Remove Step Ahead for Lategame.`}</li>
      <li parentName="ul">{`Hikari for Phase 2, Oswald Phase 1`}</li>
    </ul>
    <h6 {...{
      "id": "110"
    }}>{`1.1.0:`}</h6>
    <ul>
      <li parentName="ul">{`Cheaper/faster Partitio 1.`}</li>
      <li parentName="ul">{`Restructure early game. Get Temenos later, fight Clarissa earlier, get EM on the way to Conning Creek.`}</li>
      <li parentName="ul">{`Consistent Garnet.`}</li>
    </ul>
    <h6 {...{
      "id": "101"
    }}>{`1.0.1`}</h6>
    <p>{`Update Thurston fight to include Collect`}</p>
    <h3 {...{
      "id": "ideas--things-to-investigate"
    }}>{`Ideas / Things to Investigate`}</h3>
    <ul>
      <li parentName="ul">{`See if we can secure Dolci 2 kill without Latent`}</li>
      <li parentName="ul">{`Go through money route, tight in multiple places.`}</li>
      <li parentName="ul">{`Check Trosseau kill, can probably be optimized.`}</li>
      <li parentName="ul">{`Figure out optimal L Stone usage.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      